const o = {
  name: "Book",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8 6H16V8H8V6Z" fill="currentColor"/>
<path d="M16 10H8V12H16V10Z" fill="currentColor"/>
<path d="M4.87868 2.87868C5.44129 2.31607 6.20435 2 7 2H20V22H7C6.20435 22 5.44129 21.6839 4.87868 21.1213C4.31607 20.5587 4 19.7957 4 19V5C4 4.20435 4.31607 3.44129 4.87868 2.87868ZM6 16.1716C6.3182 16.0591 6.65606 16 7 16H18V4H7C6.73478 4 6.48043 4.10536 6.29289 4.29289C6.10536 4.48043 6 4.73478 6 5V16.1716ZM18 18H7C6.73478 18 6.48043 18.1054 6.29289 18.2929C6.10536 18.4804 6 18.7348 6 19C6 19.2652 6.10536 19.5196 6.29289 19.7071C6.48043 19.8946 6.73478 20 7 20H18V18Z" fill="currentColor"/>
</svg>
  `
};
export {
  o as Book
};
